// ui/NavStyles.js

export const navItemStyle = {
  padding: "6px 12px",
  borderRadius: 6,

  fontSize: 14,
  fontWeight: 500,
  color: "#374151",          // gray-700

  background: "transparent",
  border: "1px solid transparent",

  cursor: "pointer",
  textDecoration: "none",
  display: "inline-flex",
  alignItems: "center",
  lineHeight: 1.2,
  whiteSpace: "nowrap",

  transition: "background 0.15s ease, color 0.15s ease, border-color 0.15s ease",
};

export const navItemHover = {
  background: "#e5e7eb",     // gray-200
  color: "#111827",
};

export const navItemActive = {
  background: "#2563eb",     // blue-600
  color: "#ffffff",
};
